import LocalizedStrings from "react-localization";

export const burgerMenuStrings = new LocalizedStrings({
  en: {
    paidSocialCategory: "Paid Social",
    displayCategory: "Display",
    selfPromotionCategory: "Self Promotion",
    mappingLevel: "Mapping",
    creativeClassification: "Creative Classification",
    creativeReview: "Creative Review",
    monitoring: "Monitoring",
    mappingsView: "Mapping",
    mediaCategory: "Media",
    media: " All Mappings",
    providerworkflowMonitoring: "Provider Workflow Monitoring",
    eRetail: "eRetail Amazon",
    audience: "Audience",
    dataIngestion: "Data Ingestion",
    mediaClassification: "Media Classification",
    dataAssignment: "Data Assignment",
    creativeAnalysis: "Creative Analysis",
    spends: "Spends",
    connectedTv: "Connected TV",
    admin: "Admin",
    logout: "Log out",
    closeMenu: "Close the menu",
  },
  fr: {
    paidSocialCategory: "Paid Social",
    displayCategory: "Display",
    selfPromotionCategory: "Autopromotion",
    mappingLevel: "Mapping",
    creativeClassification: "Classification Visuel",
    creativeReview: "Revue Visuel",
    monitoring: "Monitoring",
    mappingsView: "Mapping",
    mediaCategory: "Médias",
    media: " Mapping",
    providerworkflowMonitoring: "Provider Workflow Monitoring",
    eRetail: "eRetail Amazon",
    audience: "Audience",
    dataIngestion: "Imports des données",
    mediaClassification: "Classification des domaines",
    dataAssignment: "Assignement des données",
    creativeAnalysis: "Analyse Visuel",
    spends: "Valorisation",
    connectedTv: "Connected TV",
    admin: "Administration",
    logout: "Déconnection",
    closeMenu: "Fermer le menu",
  },
});
